var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuccessLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 0C44.8615 0 0 44.8577 0 100C0 155.142 44.8615 200 100 200C155.138 200 200 155.142 200 100C200 44.8577 155.138 0 100 0ZM100 192.308C49.1038 192.308 7.69231 150.896 7.69231 100C7.69231 49.1038 49.1038 7.69231 100 7.69231C150.896 7.69231 192.308 49.1038 192.308 100C192.308 150.896 150.896 192.308 100 192.308Z",
    fill: "#34C54B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.122 58.986L88.0106 125.486L52.3991 96.9976C50.7452 95.6706 48.3183 95.9437 46.9952 97.5976C45.6683 99.2591 45.9375 101.678 47.5952 103.005L86.0568 133.774C86.7645 134.34 87.6145 134.617 88.4606 134.617C89.5222 134.617 90.5798 134.178 91.3375 133.325L152.876 64.0937C154.288 62.5091 154.145 60.0745 152.557 58.6668C150.964 57.2514 148.538 57.3937 147.122 58.986Z",
    fill: "#34C54B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccessLg);
export default __webpack_public_path__ + "static/media/icon-success-lg.cc4773c459f5f09abe83cad6c9186e14.svg";
export { ForwardRef as ReactComponent };